<template>
    <div class="ideas-filters">
        <div class="ideas-filters-row">
            <SearchWidget
                :model-value="filters.q"
                @update:model-value="$emit('update', 'q', $event)"
            />
            <div class="filter-chips">
                <span class="filter-label">Days</span>
                <button
                    v-for="option in options.duration"
                    :key="option.id"
                    type="button"
                    :class="[
                        'filter-chip',
                        { active: filters.duration.includes(option.id) },
                    ]"
                    @click="toggleDuration(option.id)"
                >
                    {{ option.id }}
                </button>
            </div>
        </div>
        <div class="ideas-filters-row">
            <MultiselectableDropdown
                v-for="dropdown in dropdowns"
                :key="dropdown.key"
                :options="options[dropdown.key]"
                :model-value="selected(dropdown.key)"
                :placeholder="dropdown.label"
                :loaded="true"
                @update:model-value="onSelect(dropdown.key, $event)"
            />
            <button
                v-if="activeCount"
                type="button"
                class="filter-clear"
                @click="$emit('clear')"
            >
                <span class="material-symbols-outlined">close</span>
                Clear
            </button>
        </div>
    </div>
</template>

<script>
import SearchWidget from "js/components/widgets/SearchWidget.vue";

export default {
    name: "SavedIdeasFilters",
    components: { SearchWidget },
    props: {
        filters: {
            type: Object,
            required: true,
        },
        options: {
            type: Object,
            required: true,
        },
        activeCount: {
            type: Number,
            default: 0,
        },
    },
    emits: ["update", "clear"],
    data() {
        return {
            dropdowns: [
                { key: "continent", label: "Continent" },
                { key: "region", label: "World region" },
                { key: "country", label: "Country" },
                { key: "month", label: "Months" },
            ],
        };
    },
    methods: {
        selected(key) {
            return this.options[key].filter((option) =>
                this.filters[key].includes(option.id)
            );
        },
        onSelect(key, selectedOptions) {
            this.$emit(
                "update",
                key,
                selectedOptions.map((option) => option.id)
            );
        },
        toggleDuration(id) {
            const current = this.filters.duration;
            this.$emit(
                "update",
                "duration",
                current.includes(id)
                    ? current.filter((value) => value !== id)
                    : [...current, id]
            );
        },
    },
};
</script>
